import React from 'react';
import { Input } from 'semantic-ui-react';
import styled from 'styled-components';
import classnames from 'classnames';

import { Label } from '@/components/shared/Label';

type Props = {
  value?: string;
  onChange: (value: string | null) => void;
  error?: string;
};

export const BillingNote: React.FC<Props> = ({ value, error, onChange }) => {
  return (
    <Styled>
      <div id="billingNote" className={classnames('field', { error })}>
        <Input
          className="billing-note"
          value={value || ''}
          onChange={(_, { value }) => onChange(value)}
        />
        {error && <Label>{error}</Label>}
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  .billing-note {
    margin-top: 7px;
    margin-bottom: 40px;
  }
`;
